/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum VendorEventStatus {
    UNKNOWN = 'Unknown',
    ACTIVE = 'Active',
    ARCHIVED = 'Archived',
}
